// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"459":"4aabcdf1","774":"0e62b620","787":"64644551"}[chunkId] + ".chunk.js";
};